import { NgModule } from '@angular/core';
import { HubLogoComponent } from './hub-logo.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
    ],
    declarations: [ HubLogoComponent ],
    exports: [ HubLogoComponent ],
})
export class HubLogoModule { }
